<template>
    <div class="kinship-wrapper">
        <div v-if="isShowTitle" class="mb20 fb">{{title}}</div>
        <avue-crud :data="data" v-if="dossierId" :option="option" v-model="form" :table-loading="loading" ref="crud" @row-del="rowDel" @row-update="rowUpdate" @row-save="rowSave" @on-load="onLoad" :before-open="beforeOpen" @error="error"></avue-crud>
        <avue-crud :data="data" v-if="!dossierId" :option="option" v-model="form" :table-loading="loading" :page.sync="page" ref="crud" @row-del="rowDel" @row-update="rowUpdate" @row-save="rowSave" @on-load="onLoad" :before-open="beforeOpen" @error="error"></avue-crud>
        <div class="tac mt15" slot>
            <el-button type="primary" size="mini" icon="el-icon-plus" v-if="isShowBtn" @click="$refs.crud.rowAdd()">{{addBtnTitle}}</el-button>
            <slot></slot>
        </div>
    </div>
</template>
<script>
import { addFollowUp, basisListFollowUp, remove, caseArchivedFollowUp, addCaseFollowUp } from '@/api/archives/follow'
import { mapGetters } from "vuex";
export default {
    props: {
        isShowTitle: {
            type: Boolean,
            default: true,
        },
        title: {
            type: String,
            default: '走访记录'
        },
        isShowBtn: {
            type: Boolean,
            default: true
        },
        addBtnTitle: {
            type: String,
            default: '添加'
        },
        dossierId: {
            type: String,
            default: ''
        },
        isOpt: {
            type: Boolean,
            default: true
        },
        list: {
            type: Array
        }
    },
    data() {
        return {
            form: {},
            loading: true,
            page: {
                pageSize: 10,
                currentPage: 1,
                total: 0
            },
            data: [],
            option: {
                size: 'mini',
                border: true,
                align: 'center',
                menuAlign: 'center',
                delBtn: true,
                viewBtn: true,
                addBtn: false,
                cellBtn: false,
                columnBtn: false,
                refreshBtn: false,
                menuBtn: false,
                labelWidth: 100,
                menu: this.isOpt,
                column: [{
                        label: '走访类型',
                        prop: 'interviewType',
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'visit-tracking_method'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                        row: true,
                        span: 24
                    },
                    {
                        label: '内容',
                        prop: 'content',
                        row: true,
                        span: 24,
                        type: "textarea",
                        rules: [{
                            required: true,
                            message: "请输入内容",
                            trigger: "blur"
                        }]
                    },
                    {
                        label: "图片",
                        prop: "imgUrls",
                        type: 'upload',
                        dataType: 'array',
                        listType: 'picture-card',
                        loadText: '图片上传中，请稍等',
                        tip: '只能上传jpg/png/pdf凭证图片，且不超过2MB',
                        action: '/api/blade-resource/oss/endpoint/put-file-attach',
                        propsHttp: {
                            res: 'data',
                            url: 'link'
                        },
                        // canvasOption: {
                        //     text: '公益项目信息化管理系统',
                        //     ratio: 0.1
                        // },
                        data: {
                            fileName: 'imgUrls'
                        },
                        span: 24,
                    },
                    {
                        label: '时间',
                        prop: 'visitTime',
                        row: true,
                        span: 24,
                        type: 'date',
                        valueFormat: "yyyy-MM-dd hh:mm:ss",
                    },
                    {
                        label: '记录人',
                        prop: 'createUserName',
                        row: true,
                        span: 24,
                        display: false
                    },
                    {
                        label: '档案id',
                        prop: 'dossierId',
                        display: false,
                        hide: true,
                        span: 24,
                        disabled: true
                    }
                ]
            }
        }
    },
    watch: {
        dossierId() {
            this.form.basisArchiveId = this.dossierId
        },
        list() {
            this.data = this.list
        },
    },
    computed: {
        ...mapGetters(["userInfo"])
    },
    mounted(){
        this.form.basisArchiveId = this.dossierId
    },
    methods: {
        rowSave(row, done, loading) {
            row.createUserName = this.userInfo.user_name
            if (!this.dossierId) {
                this.data.push(row)
                done();
                this.$emit('getList', this.data)
                return
            }
            row.basisArchiveId = this.dossierId
            addFollowUp(row).then(res => {
                this.$message({
                    type: "success",
                    message: "操作成功!"
                });
                this.data.push(res.data.data)
                this.$emit('getList', this.data)
                done();
            }, error => {
                window.console.log(error);
                done(row);
            });
        },
        rowUpdate(row, index, done, loading) {
            if (!this.dossierId) {
                this.$set(this.data, index, row)
                // [index] = row
                done();
                this.$emit('getList', this.data)
                return
            }
            addFollowUp(row).then(res => {
                this.$message({
                    type: "success",
                    message: "操作成功!"
                });
                this.$set(this.data, index, res.data.data)
                this.$emit('getList', this.data)
                done();
            }, error => {
                window.console.log(error);
                loading();
            });
        },
        rowDel(row, index) {
            if (!this.dossierId) {
                this.data.splice(index, 1)
                this.$emit('getList', this.data)
                return
            }
            this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                .then(() => {
                    return remove(row.id);
                })
                .then(() => {
                    this.data.splice(index, 1)
                    this.$emit('getList', this.data)
                    this.$message({
                        type: "success",
                        message: "操作成功!"
                    });
                });
        },
        refreshChange() {
            this.onLoad();
        },
        onLoad() {
            this.loading = true;
            if ((this.list && this.list.length > 0) || !this.form.dossierId) {
                this.data = this.list || []
                this.page.total = this.data.length;
                this.loading = false;
                return
            }
        },
        error(err) {
            this.$message.success('请填写完整信息');
        }
    }
}

</script>
<style>
.kinship-wrapper .avue-crud__menu {
    display: none !important;
}

</style>
